<div class="container mx-auto px-6 py-8">
  @if (tenderDetailsResource.isLoading()) {
    <app-loading />
  } @else if (tenderDetailsResource.value()) {
    @let tenderDetails = tenderDetailsResource.value()!;
    @if (isRfi() || isRfp()) {
      <app-tender-questionnaire-wizard
        [tenderDetails]="tenderDetails"
        [phase]="tenderPhase()!"
        [openDecision]="openDecision()"
        (accepted)="onTenderPhaseAccepted()"
      />
    } @else if (isRfd()) {
      <app-rfd-tender-wizard [tenderDetails]="tenderDetails" [openDecision]="openDecision()" />
    } @else if (isRfq()) {
      <app-rfq-tender-wizard [tenderId]="tenderId()" [openDecision]="openDecision()" />
    } @else if (isRfc()) {
      <app-rfc-tender-wizard [tenderId]="tenderId()" />
    }
  }
</div>
